// Typed wrappers for the Routing Intelligence v2 endpoints (decision D24, PRD §32): the routing decisions of a task,
// model performance with the cache summary (project or organization), and the Jev classifier status and paid test.
// The API enforces every permission (organization-level views are maintainer+).
import { api } from "./client.ts";
import type { JevStatus, JevTestInput, JevTestResult, ModelPerformanceResponse, RoutingDecision } from "./types-routing.ts";

const enc = encodeURIComponent;
const withSignal = (signal?: AbortSignal) => (signal ? { signal } : {});

/** Newest first. */
export const listTaskRoutingDecisions = (taskId: string, signal?: AbortSignal) => api<{ items: RoutingDecision[] }>(`/tasks/${enc(taskId)}/routing-decisions`, withSignal(signal));

/** Project level when `projectId` is given, otherwise organization level. */
export const getModelPerformance = (query: { projectId?: string | null; days: number; groupBy?: string }, signal?: AbortSignal) =>
  api<ModelPerformanceResponse>(query.projectId ? `/projects/${enc(query.projectId)}/model-performance` : "/model-performance", {
    query: { days: query.days, group_by: query.groupBy },
    ...withSignal(signal),
  });

export const getJevStatus = (signal?: AbortSignal) => api<JevStatus>("/providers/openrouter/jev/status", withSignal(signal));

/** Makes a real, paid classification call (capped by `max_cost_cents`). */
export const testJevClassification = (body: JevTestInput) => api<JevTestResult>("/providers/openrouter/jev/test", { method: "POST", body });
